<template>
  <div class="goods_index">
    <header-section @search_goods="to_search" :subnav_show="false" :change_color="true"></header-section>

    <div class="container mt-4">
      <div class="section-title">
        <h2>搜索结果</h2>
        <p>SEARCH</p>
      </div>
      <div class="width_center_1200">
          <div class="main_right">
            <div class="goods_list" v-if="goods_list.length > 0">
              <div class="goods_list_item" v-for="(v, k) in goods_list" :key="k">
                <router-link :to="'/product/detail/' + v.id">
                  <dl>
                    <dt>
                      <el-image :src="v.picUrl" alt="" lazy></el-image>
                    </dt>
                    <dd class="title">{{ v.name }}</dd>
                    <dd class="jianjie">{{ v.brief }}</dd>
                    <dd><span>查看详情</span></dd>
                    <!-- <dd><span>立即购买</span><span class="zhekou">{{ v.retailPrice }} 折</span></dd> -->
                  </dl>
                </router-link>
              </div>
            </div>
            <div class="home_empty_list" v-else>
              <i class="font iconfont">&#xe600;</i>暂无相关数据！
            </div>
            <div class="home_fy_block" style="clear: both;text-align: right;">
              <el-pagination @current-change="current_change" background layout="total, prev, pager, next, jumper"
                :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
            </div>
          </div>
        </div>
    </div>


    <footer-section></footer-section>
  </div>
</template>

<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"

export default {
  components: {
    HeaderSection,
    FooterSection
  },
  props: {},
  data() {
    return {
      expands: [],
      // 是否展开，默认全部展开
      isExpandAll: true,
      // 遮罩层
      loading: true,
      // 重新渲染表格状态
      refreshTable: true,

      goods_list: [],
      showDIV: false,
      currTreeNodeId: '0',
      props: {
        value: 'id',
        label: 'name',
        checkStrictly: true,
      },
      info: {
        keyword: '',
        order: 'create_time',
        page:1,
        limit:20,
        asc:false
      },
      total_data: 0, // 总条数
      page_size: 20,
      current_page: 1,
    };
  },
  watch: {
    info: {
      handler() {
        this.search_goods();
      },
      deep: true,
    }
  },
  computed: {},
  methods: {
    goods_sort_click: function (e) {
      // 是否取反
      if (e == this.info.goods_type) {
        if (this.info.order_type == 0) {
          this.info.order_type = 1;
        } else {
          this.info.order_type = 0;
        }
      } else { // 新条件先倒叙
        this.info.goods_type = e;
        this.info.order_type = 0;
      }
    },
    // 搜索指定产品
    search_goods: function () {
      this.info.page = this.current_page;
      this.$get(this.$api.searchGoodsByKeyword, this.info).then(res => {
        if (res != undefined && res != null) {
          this.page_size = res.pagesize;
          this.total_data = res.totalrecords;
          this.current_page = res.page;
          this.goods_list = res.list;
        }
      }).catch(err => { err });
    },
    // 子组件执行搜索
    to_search: function (e) {
      this.info.keyword = e.keywords;
      this.search_goods();
    },
    // 分页改变
    current_change: function (e) {
      this.current_page = e;
      this.search_goods();
    },
    get_search_where(route_info = "") {
      let params = this.$route.params.info;
      
      if (route_info != '') {
        params = route_info;
      }
      if (params != null) {
        this.info.keyword = params;
      } else {
        this.info.keyword = '';
      }
      // if(this.info.pid == 0) this.info.pid = this.info.categoryId;
      this.search_goods();
    },
  },
  created() {
    this.get_search_where();
  },
  beforeRouteUpdate: function (to, from, next) {
    if (to.path != from.path) {
      this.get_search_where(to.params.info);
    }
    next();
  },
  mounted() { }
};
</script>
<style lang="scss" scoped>
/deep/ .more{
    float: none;
}
/deep/ .el-pagination__jump{
    margin-left: 10px;
}
.main_right {
  width: 1200px;
  float: left;
  margin-left: 8px;
  margin-top: 20px;
}

a {
  cursor: pointer;
  color: blue;
}

a:link {
  text-decoration: none;
  color: blue;
}

a:hover {
  text-decoration: none;
  color: red;
}

a:active {
  text-decoration: none;
  color: red;
  background: #c7f2fa;
}

a:visited {
  text-decoration: none;
  color: black;
}

.goods_sort_top {
  position: relative;
  margin: 0 auto;
  color: #666;

  i {
    position: absolute;
    right: -16px;
    font-size: 12px;
  }
}

.goods_sort_bottom {
  position: relative;
  color: #666;

  i {
    position: absolute;
    right: -16px;
    font-size: 12px;
  }
}

.line-height-50 {
  line-height: 50px;
}

.mbx {
  margin: 30px auto;
}

.goods_list {

  // margin:40px auto;
  .goods_list_item {
    float: left;
    width: 224px;
    height: 364px;
    background-color: #fefefe;
    box-sizing: border-box;
    margin: 0 0 10px 10px;
    //border-radius: 8px;
    // border: 1px solid #dcdcdc;

    dl {
      border: 1px solid #efefef;
      box-sizing: border-box;
      width: 224px;
      height: 354px;
      -webkit-transition: all .2s linear;
      transition: all .2s linear;

      .el-image {
        width: 180px;
        height: 180px;
        margin: 30px auto 25px auto;
        display: block;
      }
    }

    dl dt img {
      width: 180px;
      height: 180px;
      margin: 30px auto 25px auto;
      display: block;
    }

    dl dd {
      font-size: 12px;
    }

    dl dd.title {
      color: #000;
      height: 36px;
      line-height: 20px;
      text-align: center;
      padding: 0 15px;
      overflow: hidden;
    }

    dl dd.price {
      color: #e01d20;
      line-height: 50px;
      text-align: center;
      padding: 0 15px;
      font-size: 14px;
      overflow: hidden;
    }

    dl dd.jianjie {
      color: #363636;
      line-height: 28px;
      text-align: center;
      padding: 0 15px;
      font-size: 12px;
      height: 38px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    dl dd span:first-child {
      box-sizing: border-box;
      color: #000;
      // background: #cc3c43;
      border-right: 1px solid #efefef;
    }

    dl dd span:first-child:hover {
      color: #fff;
      background: #033cf7;
    }

    dl dd span {
      width: 223px;
      display: block;
      border-top: 1px solid #efefef;
      float: left;
      line-height: 41px;
      text-align: center;
      background: #f1f8fd;
    }

    dl dd span.retailPrice {
      font-size: 14px;
      color: #b0b0b0;
      text-decoration: line-through;
    }

    dl dd span.zhekou {
      font-size: 14px;
      color: rgb(56, 56, 56);
      //background-color: #f74008;
    }

    dl dd span.zhekou:hover {
      color: #fff;
      background: #ca151e;
    }
	.el-image{
		text-align: center;
		/deep/ .el-image__inner{
			width: auto;
			height: 180px;
			
		}
	}
  }

  .goods_list_item:nth-child(5n) {
    margin-right: 0;
  }

  // .goods_list_item:hover{
  //     // border:1px solid #ca151e;
  // }
  .goods_list_item:hover dl {
    -webkit-transform: translateY(-3px);
    transform: translateY(-3px);
    -webkit-box-shadow: 1px 1px 20px #999;
    box-shadow: 1px 1px 20px #999;
  }
}
</style>